import { HOUR_SLOTS } from '../functions';

const COLUMN_CLASS = 'flex w-16 flex-col bg-white pr-2 text-right text-[11px] text-gray';
const HOUR_ROW_BASE_CLASS = 'flex justify-end py-1';

type HourColumnProps = Readonly<{
    rowMinClass: string;
}>;

export function HourColumn({ rowMinClass }: HourColumnProps) {
    return (
        <div className={COLUMN_CLASS}>
            {HOUR_SLOTS.map(slot => (
                <div key={slot.label} className={`${HOUR_ROW_BASE_CLASS} ${rowMinClass}`}>
                    <time dateTime={`${String(slot.hour).padStart(2, '0')}:00`}>{slot.label}</time>
                </div>
            ))}
        </div>
    );
}
